import { defineCustomElements } from "@komodo-design-system/komodo-core-web-components/loader";

console.log("Komodo-Core: pre-initialization");

defineCustomElements();


console.log("Komodo-Core: post-initialization");
